module.exports = __webpack_public_path__ + "img/2.1.70bec1b8.png";